"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
exports.default = () => {
    const POOL_SIZE = 10;
    const [generation, setGeneration] = React.useState(1);
    const [population, setPopulation] = React.useState([]);
    function measureFitness(value) {
        return 50 - Math.pow(value, 2);
    }
    function runGeneration() {
        // Are we at pool size?
        let localPopulation = [...population];
        if (localPopulation.length < POOL_SIZE) {
            // Create a brand new individual:
            const value = Math.random() * 200 - 100;
            const individual = {
                value,
                fitness: measureFitness(value),
                birthdate: generation
            };
            // Bump generation:
            let localGeneration = generation;
            localGeneration += 1;
            setGeneration(localGeneration);
            // Append and return:
            localPopulation.push(individual);
            setPopulation(localPopulation);
            return;
        }
        // We're at pool size, so pick one to be parent:
        const parentIdx = Math.floor(Math.random() * POOL_SIZE);
        const parent = localPopulation[parentIdx];
        const value = parent.value + Math.sign(Math.random() * 2 - 1.0);
        const individual = {
            value,
            fitness: measureFitness(value),
            birthdate: generation
        };
        // Bump generation
        let localGeneration = generation;
        localGeneration += 1;
        setGeneration(localGeneration);
        const chosenIdx = Math.floor(Math.random() * POOL_SIZE);
        const chosenIndividual = localPopulation[chosenIdx];
        if (chosenIndividual.fitness < individual.fitness) {
            // Replace:
            localPopulation[chosenIdx] = individual;
            setPopulation(localPopulation);
        }
    }
    return (React.createElement("div", null,
        React.createElement("p", null, "Currently reading a new book: Evolutionary Computation A Unified Approach. So far in chapter 1, we're introduced to a simple evolutionary system: EV. EV has a very basic implementation:"),
        React.createElement("ul", null,
            React.createElement("li", null, "Generate initial population with N individuals"),
            React.createElement("li", null, "Loop:"),
            React.createElement("ul", null,
                React.createElement("li", null, "Choose a parent (select randomly)"),
                React.createElement("li", null, "Make a child from that parent (mutate)"),
                React.createElement("li", null, "Pick a random candidate from current population"),
                React.createElement("li", null, "Choose whether to keep candidate or child based on higher fitness"))),
        React.createElement("p", null, "And that's it. The book then applies this simple EV system to a simple fitness landscape: f(x) = 50 - x^2"),
        React.createElement("p", null, "For mutation, the initial demonstration was using a single step mutation of 1.0 (in either +/- direction)."),
        React.createElement("p", null, "This post is going to re-implement this algorithm on this fitness function, to see if we get similar results."),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                setPopulation([]);
                setGeneration(1);
            }) }, "Reset"),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                runGeneration();
            }) }, "Run Generation"),
        React.createElement("p", null,
            "Generation: ",
            generation),
        React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Indiv"),
                    React.createElement("th", null, "birthdate"),
                    React.createElement("th", null, "fitness"),
                    React.createElement("th", null, "gene values"))),
            React.createElement("tbody", null, population.map((individual, i) => (React.createElement(React.Fragment, null,
                React.createElement("tr", null,
                    React.createElement("td", null, i),
                    React.createElement("td", null, individual.birthdate),
                    React.createElement("td", null, individual.fitness),
                    React.createElement("td", null, individual.value)))))))));
};
